// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ul[data-v-5b5c8fac]{margin-bottom:1.25rem}ul li[data-v-5b5c8fac]{font-size:1rem;line-height:1.5;margin-bottom:1.25rem;padding-left:1.25rem;position:relative}ul li[data-v-5b5c8fac]:before{content:\"•\";display:block;font-size:1.125rem;left:0;position:absolute;top:-.25rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
